import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ErrorMessage, MoneyDisplay } from "components";
import LoadingIndicator from "components/LoadingIndicator";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Transaction } from "services";
import useErrorCatcher from "utils/useErrorCatcher";
import snakeToCamel from "utils/snakeToTitle";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

let mounted = false;
const TransactionPreview = props => {
  const { transactionId, className, ...rest } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => mounted = false;
  }, [])

  useEffect(() => {
    runAsyncBlock(async () => {
      const { model } = await Transaction.detail(transactionId);
      if (mounted) setModel(model);
    }).finally(() => mounted && setLoading(false));

    return () => {
      if (mounted) setModel(null);
    };
    // eslint-disable-next-line
  }, [transactionId]);

  if (!transactionId) return null;

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title="Transaction" />
      <Divider />
      <CardContent className={classes.content}>
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        {model && (
          <Fragment>
            <Typography variant="h3"><MoneyDisplay amount={model.amount} currency={model.currency} /></Typography>
            <Typography variant="body1" >{snakeToCamel(model.type)}</Typography>
            <Typography variant="body2" >{snakeToCamel(model.subtype)}</Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/transactions/${transactionId}/summary`}>
          View Transaction Details
        </Button>
      </CardActions>
    </Card>
  );
};

TransactionPreview.propTypes = {
  className: PropTypes.string,
};

export default TransactionPreview;
